module.exports = __webpack_public_path__ + "img/teacher.b6c4160a.png";